import { Close } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useState } from "react";
import Dropzone from "react-dropzone";
import { Modal } from "./index.js";
import { baseUrl, DOWNLOAD_FILE } from "../../api/endpoints.js";
import { GalleryPicker as Gallery } from "../media/GalleryPicker.jsx";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
const MultipleImages = ({
  files,
  setFiles,
  selectedProductImage,
  setselectedProductImage,
  noMedia = false,
}) => {
  const removeFile = (name) => {
    setFiles([...files].filter((file) => file.name !== name));
  };
  const [ondrag, setOnDrag] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  /*   const [selectedProductImage, setselectedProductImage] = useState([]);
   */
  return (
    <Box
      sx={{ display: "flex", alignItems: "flex-end", gap: 3, flexWrap: "wrap" }}
    >
      <Dropzone
        onDrop={(acceptedFiles) => {
          setFiles([...files, ...acceptedFiles]);
        }}
        onDragEnter={() => setOnDrag(true)}
        onDragLeave={() => setOnDrag(false)}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <Box
              {...getRootProps()}
              sx={{
                width: "130px",
                height: "130px",
                backgroundColor: (theme) =>
                  theme.palette.mode === "light"
                    ? "#fff"
                    : theme.palette.background.paper,
                border: ondrag ? "" : "1px solid #ccc",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "36px",
                flexDirection: "column",
                padding: "10px",
              }}
              className={ondrag ? "enterDrag" : ""}
            >
              <input {...getInputProps()} accept="image/*" />
              <AddAPhotoOutlinedIcon
                sx={{
                  color: (theme) =>
                    theme.palette.mode === "light"
                      ? "rgb(107 114 128)"
                      : "rgba(255, 255, 255, 0.7)",
                }}
                fontSize="large"
              />
              <Box
                sx={{
                  color: (theme) =>
                    theme.palette.mode === "light"
                      ? "rgb(107 114 128)"
                      : "rgba(255, 255, 255, 0.7)",
                }}
                className="text-xs text-center  mt-3 "
                style={{ lineHeight: "23px" }}
              >
                فایل بکشید و رها کنید یا کلیک کنید
              </Box>
            </Box>
          </section>
        )}
      </Dropzone>
      {!noMedia && (
        <Box
          sx={{
            width: "130px",
            height: "130px",
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? "#fff"
                : theme.palette.background.paper,
            border: ondrag ? "" : "1px solid #ccc",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "36px",
            flexDirection: "column",
            padding: "10px",
          }}
          onClick={() => setOpenImageModal(true)}
          className="cursor-pointer"
        >
          <CollectionsOutlinedIcon
            sx={{
              color: (theme) =>
                theme.palette.mode === "light"
                  ? "rgb(107 114 128)"
                  : "rgba(255, 255, 255, 0.7)",
            }}
            fontSize="large"
          />
          <Box
            className="text-xs text-center  mt-3"
            style={{ lineHeight: "23px" }}
            sx={{
              color: (theme) =>
                theme.palette.mode === "light"
                  ? "rgb(107 114 128)"
                  : "rgba(255, 255, 255, 0.7)",
            }}
          >
            برای انتخاب عکس از گالری کلیک کنید
          </Box>
        </Box>
      )}

      <Box
        sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}
      >
        {files
          .map((file) => [URL.createObjectURL(file), file.name])
          .map((preview) => (
            <Box sx={{ position: "relative" }} key={preview[1]}>
              <Close
                onClick={() => removeFile(preview[1])}
                sx={{
                  backgroundColor: "error.main",
                  color: "#FFF",
                  fontSize: "16px",
                  borderRadius: "10px",
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.2)",
                  },
                  zIndex: "2",
                }}
              />
              <img
                src={preview[0]}
                alt=""
                style={{
                  height: "130px",
                  width: "130px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </Box>
          ))}
        {!noMedia &&
          selectedProductImage?.map((item, index) => (
            <Box sx={{ position: "relative" }} key={index}>
              <Close
                onClick={() => {
                  var temp = [...selectedProductImage];
                  var nf = temp.filter((r) => r !== item);
                  setselectedProductImage(nf);
                }}
                sx={{
                  backgroundColor: "error.main",
                  color: "#FFF",
                  fontSize: "16px",
                  borderRadius: "10px",
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.2)",
                  },
                  zIndex: "2",
                }}
              />
              <img
                src={`${baseUrl}/${DOWNLOAD_FILE}/${item}`}
                alt=""
                style={{
                  height: "130px",
                  width: "130px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </Box>
          ))}
      </Box>
      <Modal
        open={openImageModal}
        close={() => {
          setOpenImageModal(false);
        }}
        title="انتخاب عکس از گالری"
        autoWidth={true}
        noPadding={true}
      >
        <div className="h-full overflow-y-auto pl-12 xl:min-w-[95vw]">
          {/*    <div className="flex">
            <span></span>
          </div> */}
          <Gallery
            choosable={true}
            setSelceted={(e) => {
              var temp = [...selectedProductImage];
              temp.push(e);
              setselectedProductImage(temp);
              setOpenImageModal(false);
            }}
          />
        </div>
      </Modal>
    </Box>
  );
};

export default MultipleImages;
